import { Injectable } from '@angular/core';
import {Capacitor, CapacitorHttp, HttpResponse, registerPlugin} from "@capacitor/core";
import {BackgroundGeolocationPlugin, WatcherOptions} from "@capacitor-community/background-geolocation";
const BackgroundGeolocation = registerPlugin<BackgroundGeolocationPlugin>("BackgroundGeolocation");
import { ApiService } from './api.service';
import { EventKnightService } from './eventKnight.service';
// import { ForegroundService } from '@capawesome-team/capacitor-android-foreground-service';
// import {BackgroundFetch} from '@transistorsoft/capacitor-background-fetch';
import { StorageService } from './storage.service';
import { ForegroundService, ServiceType } from '@capawesome-team/capacitor-android-foreground-service';
import { Geolocation } from '@capacitor/geolocation';
// import { Http } from '@capacitor-community/http';
import { environment } from 'src/environments/environment';
import { LocationService } from './location.service';
import { AuthService } from './auth.service';
import { BgServiceSettings } from '../shared/models/event.model';
import { isInsideGeofence } from '../helpers/geofence.helper';
import { resolveStaffMovementMode } from '../helpers/staff-movement.helper';
import { LocalNotificationService } from './localNotification.service';
import { LocalNotifcationConstants } from './utils/constants';
import { PreferenceService } from './preference.service';

@Injectable({
  providedIn: 'root',
})
export class LocationBackgroundService {
  private watchId: string | null = null;
  private locations: any[] = []; // Queue for storing locations
  private intervalId: any = null;
  private heartbeatFallbackInterval: any = null;

  constructor(private apiService: ApiService, 
    private storageService: StorageService,
    private eventKnightService: EventKnightService,
    private authService: AuthService,
    private localNotificationService: LocalNotificationService,
    private preferenceService: PreferenceService,
    private dbLocationService: LocationService) {}


  async requestPermissions() {
    await ForegroundService.requestPermissions()
  }

  isEnabled = false;
  async enableForegroundService() {
    try {
      const permission = await ForegroundService.requestPermissions();
      console.log("enableForegroundService", permission.display);
      if(permission.display === 'granted') {
          // if(this.isEnabled)
          //   return;
          // await ForegroundService.startForegroundService({
          //     id: 1,
          //     title: 'Location Tracking',
          //     body: 'Location Tracking Enabled',
          //     smallIcon: 'ic_stat_name',
          //     serviceType: ServiceType.Location
          // });
          this.isEnabled = true;
      }
    }catch(err) {
      console.log(err);
    }
    
  }

  async disableForegroundService() {
    // if(!this.isEnabled)
    //   return;

    await ForegroundService.stopForegroundService();
  }


  lastWatchTimestamp = Date.now();
  watchIdV2: any;
  invervalLocationV2: any;
  sendLocationInterval: any;
  latestPosition: any;
  async startTrackingV2() {
    const userId = await this.storageService.get('location_user_id');
    if (!userId) return;

    const shiftData = await this.storageService.get('ShiftData');

    // Start watching GPS
    this.watchIdV2 = Geolocation.watchPosition(
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 10000
      },
      (position, error) => {
        if (error) {
          console.error('watchPosition error:', error);
          return;
        }

        if (position) {
          console.log('Watch position:', position);
          this.lastWatchTimestamp = Date.now();
          this.latestPosition = position; // Store latest position only, do not send yet
        }
      }
    );

    // Send to API every 60 seconds if we have a recent position
    this.sendLocationInterval = setInterval(() => {
      if (this.latestPosition && shiftData) {
        const bodyData = {
          ...this.latestPosition.coords,
          ...shiftData,
          isActive: true,
          time: this.latestPosition.timestamp
        };
        this.sendLocationDataToServer(bodyData);
      } else {
        console.warn('No valid position or shift data to send.');
      }
    }, 60_000);

    // Start fallback interval to force location update if watch fails
    this.invervalLocationV2 = setInterval(async () => {
      const now = Date.now();
      const diff = now - this.lastWatchTimestamp;

      if (diff > 90_000) { // No updates from watch recently
        console.warn('Watch not triggered recently. Forcing location refresh.');

        try {
          const position = await Geolocation.getCurrentPosition({
            enableHighAccuracy: true,
            timeout: 8000,
            maximumAge: 0
          });
          console.log('Interval fallback position:', position);
          this.lastWatchTimestamp = Date.now();
          this.latestPosition = position; // Update latest position
        } catch (err) {
          console.error('Fallback getCurrentPosition error:', err);
        }
      }
    }, 60_000);
  }


  sendLocationDataToServer(bodyData: any) {
    fetch(`${environment.apiEndpoint}/eventKnight/location/background/ping`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: bodyData ? JSON.stringify(bodyData) : null,
    }).then(res => {
      console.log(res);
    });
  }

  lastInsideStatus: boolean | null = null;
  async startTrackingV3(bgObject: BgServiceSettings) {
    // debugger;
    console.log('startTrackingV3', bgObject);
    // Staff Movement Display config (Off/Realtime/Interval + the mobile platforms it applies to, from the
    // roster's RosterSnapshot) — Off means no background tracking of any kind for this duty session, so
    // skip registering the native watcher entirely rather than letting it run and gating individual
    // writes. A platform the admin switched off (e.g. iOS on an Android-only roster) resolves to Off too.
    const staffMovementMode = resolveStaffMovementMode(
      bgObject.staffMovementDisplayMode,
      bgObject.staffMovementPlatforms,
      Capacitor.getPlatform()
    );
    if (staffMovementMode === 'Off') {
      console.log('startTrackingV3: Staff Movement Display is Off (or disabled for this platform) — skipping background tracking.');
      return;
    }

    // Battery: distanceFilter/stale are the only tuning knobs this native plugin exposes (see
    // WatcherOptions) — distanceFilter:0 keeps the GPS chip awake continuously and fires the JS callback
    // on every few-centimetre nudge, which is the main source of staff complaints about heat/battery
    // drain. Realtime still wants near-instant updates so only filters out pure GPS jitter. Interval's
    // distanceFilter comes straight from the admin's roster config (staffMovementIntervalMeters) — this
    // IS the real "how far staff must move before the dashboard refreshes" control now, not a time-based
    // throttle layered on top — so handleLocation below always sends when it's called, for every mode.
    const REALTIME_DISTANCE_FILTER_METERS = 5;
    const DEFAULT_INTERVAL_DISTANCE_FILTER_METERS = 30; // fallback for legacy rosters with no meters value saved yet
    const distanceFilter = staffMovementMode === 'Realtime'
      ? REALTIME_DISTANCE_FILTER_METERS
      : (bgObject.staffMovementIntervalMeters ?? DEFAULT_INTERVAL_DISTANCE_FILTER_METERS);
    const stale = staffMovementMode !== 'Realtime';

    // Geofence in/out hysteresis — distanceFilter above already cuts most GPS jitter, but a staff member
    // standing right on a site boundary can still flip sides between consecutive fixes. Require this many
    // consecutive readings on the new side before treating the transition as real (avoids spamming a ping
    // + local notification on every flap).
    const GEOFENCE_HYSTERESIS_READINGS = 2;

    // How often the fallback below checks whether the watcher has gone quiet, and how long it lets pass
    // before forcing a fix itself. Threshold matches the existing 60*15 heartbeat cadence further down —
    // see handleLocation — so a stationary staff member never goes longer without a server update than
    // they would have before distanceFilter was introduced.
    const HEARTBEAT_FALLBACK_CHECK_MS = 60_000;
    const HEARTBEAT_FALLBACK_THRESHOLD_MS = 15 * 60_000;

    try {
      // const userId = await this.storageService.get('location_user_id');
      // if(!userId)
      //   return;

      // const shiftData = await this.storageService.get('ShiftData');

      // await this.dbLocationService.init();

      let lastLocation: any = null;
      let lastOutSideLocation: any = null;
      let pendingInsideState: boolean | null = null;
      let pendingInsideCount = 0;
      let lastCallbackAt = Date.now();

      // Shared by both the real native watcher below and the heartbeat fallback timer — distanceFilter
      // means the watcher stays silent while the staff member is stationary, so this same handler also
      // gets invoked (with a one-shot fix) by the fallback when the watcher has been quiet too long.
      const handleLocation = async (location: any) => {
        // console.log('New Location ios:', location?.latitude);
        // onsole.log('Last Location:', lastLocation);

        const userId = bgObject.user_id;
        const tenantId = bgObject.tenantId;
        const isStartedDuty = bgObject.isStartedDuty;
        const rosterId = bgObject.rosterId ?? '';
        const shiftId = bgObject.shifId ?? '';
        // console.log(userId, tenantId, isStartedDuty);

        try{

          console.log(`New Location BG update`, location);

          if(!location)
            return;

          // Drop low-accuracy / stale / jumping fixes (e.g. the cell-tower fallback fix returned inside an
          // elevator) before they reach Firebase, the API or the geofence logic below.
          const quality = this.dbLocationService.qualityGate.evaluate({
            lat: location.latitude,
            lng: location.longitude,
            accuracy: location.accuracy,
            speed: location.speed,
            time: location.time,
          });
          if (!quality.accept) {
            console.log(`New Location BG rejected: ${quality.reason}, accuracy: ${location.accuracy}`);
            return;
          }

          if (isStartedDuty) {
            // distanceFilter above already governs how often this callback fires for Interval mode
            // (native watcher stays silent until staff move the configured distance), so no additional
            // time-based throttle is needed here — always push to Firebase whenever handleLocation runs.
            try{
              console.log(`New Location speed: ${location.speed} and accuracy: ${location.accuracy}`);
              await this.dbLocationService.updateUserLocationByApi(tenantId,
                userId, location.latitude,
                location.longitude,
                rosterId,
                shiftId
              );
            }catch(e){
              console.log('New Location ios updateUserLocation:', e);
            }
          }

          // Fixes between PRECISE_ACCURACY_METERS and MAX_ACCURACY_METERS are good enough to show on the
          // dashboard but not to decide geofence inside/outside, so only the periodic server ping runs.
          if (isStartedDuty && !quality.precise) {
            if(!lastLocation || this.isTimeSpanAtLeast(location, lastLocation, 60*15)) {
              lastLocation = location;
              await this.doPostWithAuth(location, bgObject);
            }
          } else if (isStartedDuty) {
            /*
            if(lastLocation == null || this.isTimeSpanAtLeastOneMinute(location, lastLocation))
            {
              lastLocation = location;
              await this.doPostWithAuth(location, bgObject);
            }
            */

            const userLocation = {
              lat: location.latitude,
              lng: location.longitude,
            }
            const inside = isInsideGeofence(userLocation, bgObject.geofence!);
            // console.log(inside);
            if (inside === this.lastInsideStatus) {
              pendingInsideState = null;
              pendingInsideCount = 0;
              if(!lastLocation || this.isTimeSpanAtLeast(location, lastLocation, 60*15)) {
                // console.log('1 minute', location, lastLocation);
                lastLocation = location;
                await this.doPostWithAuth(location, bgObject);
              }
            } else {
              // Disagrees with the confirmed side — require GEOFENCE_HYSTERESIS_READINGS consecutive
              // readings on the new side before treating it as a real transition, so GPS jitter near a
              // site boundary doesn't spam a ping + local notification on every flap.
              pendingInsideCount = pendingInsideState === inside ? pendingInsideCount + 1 : 1;
              pendingInsideState = inside;
              if (pendingInsideCount >= GEOFENCE_HYSTERESIS_READINGS) {
                const message = inside ? 'You are inside the geofence ✔️' : 'You are outside the geofence 🚨';
                this.localNotificationService.sendLocalNotification(LocalNotifcationConstants.NotificationId.INSIDE_OUTSIDE, message, "Location notification");
                // console.log('send location to server inside', inside);
                await this.doPostWithAuth(location, bgObject);
                this.lastInsideStatus = inside;
                lastLocation = location;
                pendingInsideState = null;
                pendingInsideCount = 0;
              }
            }

            // Send firebase notification when user is outside
            const isNotifyRealtimeWhenOutSide = bgObject.isAlertWhenOutside;
            // console.log(isNotifyRealtimeWhenOutSide, inside, this.isTimeSpanAtLeast(location, lastOutSideLocation, 10));
            if (isNotifyRealtimeWhenOutSide && !inside && (!lastOutSideLocation || this.isTimeSpanAtLeast(location, lastOutSideLocation, 60*60))) {
              const message = 'You are outside the geofence 🚨';
              lastOutSideLocation = location;
              //this.localNotificationService.sendLocalNotification(LocalNotifcationConstants.NotificationId.INSIDE_OUTSIDE, message, "Location notification");
              await this.doPostOutsideAlertWithAuth(location, bgObject);
            }
          }
        }catch(e){
          console.log('New Location ios saveLocationToStorage:', e);
        }
      };

      this.watchId = await BackgroundGeolocation.addWatcher(
        {
          backgroundMessage: 'Tracking location in the background',
          backgroundTitle: 'Location Tracking Enabled',
          requestPermissions: true,
          stale,
          distanceFilter,
        },
        async (location, error) => {
          if (error) {
            console.error('Error:', error);
            return;
          }
          lastCallbackAt = Date.now();
          await handleLocation(location);
        }
      );

      if (this.heartbeatFallbackInterval) {
        clearInterval(this.heartbeatFallbackInterval);
      }
      this.heartbeatFallbackInterval = setInterval(async () => {
        if (!bgObject.isStartedDuty) return;
        if (Date.now() - lastCallbackAt < HEARTBEAT_FALLBACK_THRESHOLD_MS) return;

        try {
          const position = await Geolocation.getCurrentPosition({
            enableHighAccuracy: true,
            timeout: 8000,
            maximumAge: 0
          });
          lastCallbackAt = Date.now();
          await handleLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            accuracy: position.coords.accuracy,
            altitude: position.coords.altitude,
            altitudeAccuracy: position.coords.altitudeAccuracy,
            speed: position.coords.speed,
            time: position.timestamp,
          });
        } catch (e) {
          console.log('Heartbeat fallback getCurrentPosition error:', e);
        }
      }, HEARTBEAT_FALLBACK_CHECK_MS);
    }
    catch(err) {
      console.error(err);
    }


  }

  // async startTracking() {

  //   try {
  //     // const userId = await this.storageService.get('location_user_id');
  //     // if(!userId)
  //     //   return;

  //     // const shiftData = await this.storageService.get('ShiftData');
  
  //     let lastLocation: any = null;
  //     this.watchId = await BackgroundGeolocation.addWatcher(
  //       {
  //         backgroundMessage: 'Tracking location in the background',
  //         backgroundTitle: 'Location Tracking Enabled',
  //         requestPermissions: true,
  //         stale: false,
  //         distanceFilter: 0,
  //       },
  //       async (location, error) => {
  //         if (error) {
  //           console.error('Error:', error);
  //           return;
  //         }
  //         console.log('New Location ios:', location?.latitude);
  //         // onsole.log('Last Location:', lastLocation);

  //         const userId = '3923FDD2-08FC-4513-BF7A-D5543BABEAE2';
  //         const tenantId = 'DDD9E4A8-07D6-49F8-B6E0-99DFD8F280F1';
  //         const isStartedDuty = true;
  //         console.log(userId, tenantId, isStartedDuty);

  //         try{
  //           // await this.saveLocationToStorage(location, userId);
  //         if(location) {
  //           // const isStartedDuty = await this.storageService.get('isStartedDutyToday');
  //           // console.log('New Location ios duty:', isStartedDuty);
  //           if (isStartedDuty) {
  //             try{
                
  //               this.dbLocationService.updateUserLocation(tenantId,
  //                 userId, location.latitude, 
  //                 location.longitude);
  //             }catch(e){
  //               console.log('New Location ios updateUserLocation:', e);
  //             }
             
  //           }

  //           if (isStartedDuty) {
  //             if(lastLocation == null || this.isTimeSpanAtLeastOneMinute(location, lastLocation))
  //             {
  //               lastLocation = location;
  //               // await this.sendLocationToServer(location);
  //               await this.doPost(location);
  //             }
  //           }
  //         }
  //         }catch(e){
  //           console.log('New Location ios saveLocationToStorage:', e);
  //         }
          
  //         // Prevent case too much data
  //         // if(lastLocation == null || this.isTimeSpanAtLeastOneMinute(location, lastLocation))
  //         // {
  //         //   console.log('New Location:', location);
  //         //   console.log('Last Location:', lastLocation);
  //         //   // await this.saveLocationToStorage(location, userId);
  //         //   const bodyData = {
  //         //       ...location,
  //         //       ...shiftData,
  //         //       isActive: true
  //         //   };
  //         //   console.log('Last Location Body:', bodyData);
  //         //   this.sendLocationDataToServer(bodyData);
  //         //   lastLocation = location;
  //         // }
  //       }
  //     );

  //     // Start watching GPS
  //     // this.watchIdV2 = Geolocation.watchPosition(
  //     //   {
  //     //     enableHighAccuracy: true,
  //     //     timeout: 30000,
  //     //     maximumAge: 30000
  //     //   },
  //     //   (position, error) => {
  //     //     if (error) {
  //     //       console.error('watchPosition error:', error);
  //     //       return;
  //     //     }

  //     //     if (position) {
  //     //       console.log('Watch position:', position);
  //     //       const lvPosition = {
  //     //         ...position.coords,
  //     //         time: position.timestamp
  //     //       }

  //     //       if(lastLocation == null || this.isTimeSpanAtLeastOneMinute(lvPosition, lastLocation))
  //     //       {
  //     //         console.log('New Location 2:', lvPosition);
  //     //         console.log('Last Location 2:', lastLocation);
  //     //         const bodyData = {
  //     //           ...lvPosition,
  //     //           ...shiftData,
  //     //           isActive: true
  //     //         };
  //     //         console.log('Last Location Body 2:', bodyData);
  //     //         this.sendLocationDataToServer(bodyData);
  //     //         lastLocation = lvPosition;
  //     //       }
  //     //       // this.lastWatchTimestamp = Date.now();
  //     //       // this.latestPosition = position; // Store latest position only, do not send yet
  //     //     }
  //     //   }
  //     // );
  
  //     // console.log(this.watchId);

  //     // BackgroundGeolocation.addWatcher(
  //     //   {
  //     //       // If the "backgroundMessage" option is defined, the watcher will
  //     //       // provide location updates whether the app is in the background or the
  //     //       // foreground. If it is not defined, location updates are only
  //     //       // guaranteed in the foreground. This is true on both platforms.

  //     //       // On Android, a notification must be shown to continue receiving
  //     //       // location updates in the background. This option specifies the text of
  //     //       // that notification.
  //     //       backgroundMessage: "Cancel to prevent battery drain.",

  //     //       // The title of the notification mentioned above. Defaults to "Using
  //     //       // your location".
  //     //       backgroundTitle: "Tracking You.",
            
  //     //       // Whether permissions should be requested from the user automatically,
  //     //       // if they are not already granted. Defaults to "true".
  //     //       requestPermissions: true,

  //     //       // If "true", stale locations may be delivered while the device
  //     //       // obtains a GPS fix. You are responsible for checking the "time"
  //     //       // property. If "false", locations are guaranteed to be up to date.
  //     //       // Defaults to "false".
  //     //       stale: false,

  //     //       // The minimum number of metres between subsequent locations. Defaults
  //     //       // to 0.
  //     //       distanceFilter: 50,
  //     //   },
  //     //   function callback(location, error) {
  //     //       if (error) {
  //     //           if (error.code === "NOT_AUTHORIZED") {
  //     //               if (window.confirm(
  //     //                   "This app needs your location, " +
  //     //                   "but does not have permission.\n\n" +
  //     //                   "Open settings now?"
  //     //               )) {
  //     //                   // It can be useful to direct the user to their device's
  //     //                   // settings when location permissions have been denied. The
  //     //                   // plugin provides the 'openSettings' method to do exactly
  //     //                   // this.
  //     //                   BackgroundGeolocation.openSettings();
  //     //               }
  //     //           }
  //     //           return console.error(error);
  //     //       }


  //     //       return console.log(location);
  //     //   }
  //     // ).then((watcher_id) => {
  //     //     // When a watcher is no longer needed, it should be removed by calling
  //     //     // 'removeWatcher' with an object containing its ID.
  //     //     // BackgroundGeolocation.removeWatcher({
  //     //     //     id: watcher_id
  //     //     // });
  //     //     console.log('watcher_id', watcher_id);
  //     //     this.watchId = watcher_id;
  //     // });
  //   }
  //   catch(err) {
  //     console.error(err);
  //   }

    

  //   // Start interval for location saving every 1 minute
  //   // this.intervalId = setInterval(async () => {
  //   //   // const location = await this.getCurrentLocation();
  //   //   // if (location) {
  //   //   //   console.log('Saving location to storage:', location);
  //   //   //   await this.saveLocationToStorage(location, userId);
  //   //   // }
  //   //   this.getCurrentLocation(userId);

  //   // }, 60000); // 1 minute interval
  //   // this.intervalId = setInterval(async () => {
      

      

  //   //   // Optionally send to server
  //   // }, 30000); // every 10 seconds

    

  // }


  async doPost(loc: any) {
    console.log('Request', loc);
    //const user = await this.authService.getCurrentUserValue();
    const options = {
      url: `${environment.apiEndpoint}/eventKnight/location/ping`,
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      data: { ...loc },
    };
    const response: HttpResponse = await CapacitorHttp.post(options);
    console.log(response);    
  }


  async doPostWithAuth(loc: any, bgObject: BgServiceSettings) {
    // console.log('Request', loc);
    //const user = await this.authService.getCurrentUserValue();
    const options = {
      url: `${environment.apiEndpoint}/eventKnight/location/update`,
      headers: { 'Authorization': `${bgObject.token_type} ${bgObject.access_token}`, 'Content-Type': 'application/json', 'Accept': 'application/json' },
      data: { ...loc, shiftId: bgObject.shifId, rosterId: bgObject.rosterId, rosterStaffAssignmentId: bgObject.rosterStaffAssignmentId },
    };
    const response: HttpResponse = await CapacitorHttp.post(options);
    // console.log(response);    
  }

  async doPostOutsideAlertWithAuth(loc: any, bgObject: BgServiceSettings) {
    // console.log('Request', loc);
    //const user = await this.authService.getCurrentUserValue();
    const options = {
      url: `${environment.apiEndpoint}/eventKnight/location/notify-outside`,
      headers: { 'Authorization': `${bgObject.token_type} ${bgObject.access_token}`, 'Content-Type': 'application/json', 'Accept': 'application/json' },
      data: { ...loc, shiftId: bgObject.shifId, rosterId: bgObject.rosterId, siteName: bgObject.siteName },
    };
    console.log('send outside request', options);
    const response: HttpResponse = await CapacitorHttp.post(options);
    console.log(response);    
  }




  testInterval: any;
  // async startTracking() {

  //   try {
  //     const userId = await this.storageService.get('location_user_id');
  //     if(!userId)
  //       return;

  //     const shiftData = await this.storageService.get('ShiftData');

  //     if(this.testInterval)
  //       clearInterval(this.testInterval);

  //     this.testInterval = setInterval(async () => {
  //       try {
  //         console.log('interval running');
  //         const pos = await Geolocation.getCurrentPosition();

  //         let bodyData = null; 
  //         if(pos && shiftData)
  //         {
  //           bodyData = {
  //             ...pos.coords,
  //             ...shiftData,
  //             isActive: true
  //           };
  //           // console.log('Test', bodyData);
  //         }

  //         const response = await fetch(`${environment.apiEndpoint}/eventKnight/location/background/ping`, {
  //           method: 'POST',
  //           headers: { 'Content-Type': 'application/json' },
  //           body: bodyData ? JSON.stringify(bodyData) : null,
  //         });

  //         console.log('Success:', response);
  //       } catch (error) {
  //         console.error('Error getting location:', error);
  //       }
       
  //     }, 60_000);
  //   }
  //   catch(err) {
  //     console.error(err);
  //   }
    

  // }

  isTimeSpanAtLeastOneMinute(loc1: any, loc2: any): boolean {
    const time1 = loc1.time;
    const time2 = loc2.time;
  
    const diffInMs = Math.abs(time1 - time2);
    const oneMinuteInMs = 60 * 1000;

    console.log(loc1, loc2, diffInMs, oneMinuteInMs, diffInMs >= oneMinuteInMs);
  
    return diffInMs >= oneMinuteInMs;
  }

  isTimeSpanAtLeast(loc1: any, loc2: any, seconds: number): boolean {
    // console.log(loc1, loc2);
    if(!loc1 || !loc2) 
      return false;

    const time1 = loc1.time ?? loc1.timestamp;
    const time2 = loc2.time ?? loc2.timestamp;
  
    const diffInMs = Math.abs(time1 - time2);
    const oneMinuteInMs = seconds * 1000;

    // console.log(loc1, loc2, diffInMs, oneMinuteInMs, diffInMs >= oneMinuteInMs);
  
    return diffInMs >= oneMinuteInMs;
  }


  async saveLocationToStorage(location: any, userId: string) {
    

    if(!location)
      return;

    if(location === null) 
      return;    

    const newLocation = {
      ...location,
      userId
    }

    console.log('location', location);

    let storedLocations = await this.getLocationsFromStorage();    
    storedLocations.push(newLocation);
    this.storageService.set('locations', JSON.stringify(storedLocations));
  }

  async getLocationsFromStorage(): Promise<any[]> {
    // const data = await Storage.get({ key: 'locations' });
    const data = await this.storageService.get('locations');
    console.log('storageData', data);
    return data ? JSON.parse(data) : [];
  }

  async getCurrentLocation(userId: string) {
    // return new Promise((resolve, reject) => {
    //   navigator.geolocation.getCurrentPosition(
    //     (position) => {
    //       resolve({
    //         latitude: position.coords.latitude,
    //         longitude: position.coords.longitude,
    //         timestamp: position.timestamp,
    //         accuracy: position.coords.accuracy,
    //         altitude: position.coords.altitude,
    //         speed: position.coords.speed
    //       });
    //     },
    //     (error) => {
    //       reject(error);
    //     },
    //     { enableHighAccuracy: true }
    //   );
    // });
    // try {
    //   const location = await BackgroundGeolocation.getCurrentPosition({
    //     timeout: 10000, // 10 seconds timeout
    //     enableHighAccuracy: true,
    //   });

    //   console.log('Location fetched from interval:', location);
    //   await this.saveLocation(location);
    // } catch (error) {
    //   console.error('Error getting location:', error);
    // }
    function callback(location: any, error: any = null) {
      if (error) {
          if (error.code === "NOT_AUTHORIZED") {
              if (window.confirm(
                  "This app needs your location, " +
                  "but does not have permission.\n\n" +
                  "Open settings now?"
              )) {
                  // It can be useful to direct the user to their device's
                  // settings when location permissions have been denied. The
                  // plugin provides the 'openSettings' method to do exactly
                  // this.
                  BackgroundGeolocation.openSettings();
              }
          }
          return console.error(error);
      }
      return console.log(location);
    }


    let last_location : any;
    BackgroundGeolocation.addWatcher(
        {
            requestPermissions: false,
            stale: true
        },
        function (location) {
            last_location = location || undefined;
        }
    ).then((id) => {
        setTimeout(async () => {
            callback(last_location);

            if(last_location)
              await this.saveLocationToStorage(last_location, userId);

            BackgroundGeolocation.removeWatcher({id});
        }, 1000);
    });


    
  }


  

  // async initializeBackgroundFetch(evnentId: string, geofence: string) {
  //   await BackgroundFetch.configure(
  //     {
  //       minimumFetchInterval: 15, // Executes every 15 minutes
  //       stopOnTerminate: false,
  //       enableHeadless: true,
  //     },
  //     async (taskId) => {
  //       console.log('Background fetch triggered');
  //       console.log(this.locations);
  //       await this.sendLocationToServer2(evnentId, geofence); // Send stored locations
  //       BackgroundFetch.finish(taskId);
  //     },
  //     async (error) => {
  //       console.error('Background fetch failed:', error);
  //     }
  //   );
  // }

  // async stopTracking() {
  //   if (this.watchId) {
  //     await this.disableForegroundService();
    
  //     await BackgroundGeolocation.removeWatcher({ id: this.watchId });
  //     this.watchId = null;
  //   }
  // }

  async stopTracking() {
    console.log('Location tracking stopped.');
    try {
      // await this.disableForegroundService();
    }
    catch{}    

    if (this.watchId) {
      await BackgroundGeolocation.removeWatcher({ id: this.watchId });
      this.watchId = null;
    }
    if (this.watchIdV2) {
      Geolocation.clearWatch({ id: this.watchIdV2 });
      this.watchIdV2 = null;
    }
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }

    if(this.testInterval)
    {
      clearInterval(this.testInterval);
      this.testInterval = null;
    }

    if(this.invervalLocationV2) {
      clearInterval(this.invervalLocationV2);
      this.invervalLocationV2 = null;
    }     
    
    if(this.sendLocationInterval) {
      clearInterval(this.sendLocationInterval);
      this.sendLocationInterval = null;
    }

    if (this.heartbeatFallbackInterval) {
      clearInterval(this.heartbeatFallbackInterval);
      this.heartbeatFallbackInterval = null;
    }
  }

  // isInsidePolygon(geofenceValue: string, location: any) {
  //   // this.event.geofenceValue
  //   const storedGeofences = JSON.parse(geofenceValue);
  //   let isInside = false;
  //   storedGeofences.forEach((geofence: any) => {
  //       const inside = this.isPointInPolygon(location, geofence);
  //       isInside = inside;
  //   });

  //   return isInside;
  // }

  // isPointInPolygon(point: google.maps.LatLngLiteral, polygon: google.maps.LatLngLiteral[]): boolean {
  //   let isInside = false;
  //   const x = point.lat, y = point.lng;
  
  //   for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
  //     const xi = polygon[i].lat, yi = polygon[i].lng;
  //     const xj = polygon[j].lat, yj = polygon[j].lng;
  
  //     const intersect =
  //       yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
  
  //     if (intersect) isInside = !isInside;
  //   }
  
  //   return isInside;
  // }

  async sendLocationToServer(location: any) {    
    try {
        const shiftId = await this.storageService.get('currentShift');
        const rosterId = await this.storageService.get('currentRosterId');

        const beacon = await this.preferenceService.getCurrentBeaconLocalData();
        const model = {
            latitude: location.lat,
            longitude: location.lng,
            accuracy: location.accr,
            isActive: true,
            altitude: location.alt,
            altitudeAccuracy: location.altAccr,
            speed: location.speed,
            time: location.time,
            shiftId: shiftId,
            rosterId: rosterId,
            rssi: beacon?.rssi,
            floor: beacon?.major,
            unit: beacon?.minor,
            state: beacon?.state,
            beaconId: beacon?.beaconId,
            floorCode: beacon?.floorCode,
            roomCode: beacon?.roomCode
        }
        
        const response = await this.eventKnightService.updateLocation(model).toPromise();
        console.log('Location sent successfully:', response);
        // this.eventKnightService.updateLocation(model).subscribe(async (res) => {
        //     console.log('Location sent successfully:', response);            
        // });      
    } catch (error) {
      console.error('Error sending location:', error);
    }
  }


  // async sendLocationToServer2(evnentId: string, geofence: string) {
  //   if (this.locations.length === 0) return; // Don't send if there's no data

  //   const apiUrl = 'https://your-api.com/location/update'; // Replace with your API

  //   try {

  //       console.log('Prepare to send:', this.locations);

  //       const payload = this.locations.map(location => ({
  //           latitude: location.lat,
  //           longitude: location.lng,
  //           accuracy: location.accr,
  //           isActive: true,
  //           eventId: evnentId,
  //           isInside: this.isInsidePolygon(geofence, location), // Later will change
  //           altitude: location.alt,
  //           altitudeAccuracy: location.altAccr,
  //           speed: location.speed,
  //       }));
       


  //       const response = await this.eventKnightService.updateListLocationBackground(payload).toPromise();
  //       console.log('Location sent successfully:', payload);
  //       this.locations = []; // Clear queue after successful send

  //   } catch (error) {
  //     console.error('Error sending location:', error);
  //   }
  // }

  async sendStoredLocationsToServer(userId: string) {
    let locations = await this.getLocationsFromStorage();
    // console.log(locations);

    var userLocations = locations.filter((location: any) => location.userId === userId);
    if (userLocations.length === 0) return; // No data to send

    try {

        const chunkSize = 100; // or whatever size is optimal
        const pagedLocations = this.chunkArray(userLocations, chunkSize);

        // const payload = userLocations;
        // const response = await this.eventKnightService.updateListLocationBackground(payload).toPromise();
        // console.log('Location sent successfully:', payload);

        // Send chunks to server
        for (const chunk of pagedLocations) {
          await await this.eventKnightService.updateListLocationBackground(chunk).toPromise();//this.sendToServer(chunk);
          await this.delay(500); // wait 200ms between requests
        }
       
        // Remove userLocations from locations Storage
        const remainingLocations = locations.filter((location: any) => location.userId !== userId);
        this.storageService.set('locations', JSON.stringify(remainingLocations));
    } catch (error) {
      console.error('Error sending location:', error);
    }
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  chunkArray<T>(array: T[], chunkSize: number): T[][] {
    const chunks: T[][] = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  }
}
